<template>
    <div id="instrument-create">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vx-card class="mb-base" title="Form Instrument">
            <vue-form-generator
              tag="div"
              :schema="schema"
              :model="model"
              :options="formOptions"
              @model-updated="listen"
            ></vue-form-generator>
          </vx-card>
         <vs-card class="mb-base" style="width: 80%" vs-justify="center">
           <div slot="header">
             <vs-row vs-w="12">
               <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                 <h4>Daftar Pemeriksaan & Produk</h4>
               </vs-col>
 					     <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="12">
     	          <vs-spacer></vs-spacer>
     						<vs-tooltip text="Tambah">
     							<vs-button radius size="medium" type="border" color="#5d9fc6" icon="add" class="ml-3" @click="openPopup"></vs-button>
     						</vs-tooltip>
               </vs-col>
             </vs-row>
           </div>
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2">
                <vs-table stripe :data="listMapping" noDataText="Tidak Ada Data" style="text-align:center; max-height:360px; overflow:scroll">
                    <template slot="thead">
                        <vs-th>Kode</vs-th>
                        <vs-th>Pemeriksaan</vs-th>
                        <vs-th>Produk</vs-th>
                        <vs-th>&nbsp;</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{data[indextr].measure.htCode}}
                            </vs-td>                          
                            <vs-td>
                                {{data[indextr].measure.name}}
                            </vs-td>
                            <vs-td>
                                {{data[indextr].product.name}}
                            </vs-td>
                            <vs-td>
                                <vs-button radius style="cursor: pointer;" @click="openConfirm(indextr)" color="danger" icon="delete"></vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
              </div>
           </div>
         </vs-card>
         <vs-card class="mb-base" style="width: 80%" vs-justify="center">
           <div slot="header">
             <vs-row vs-w="12">
               <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="12">
                 <h4>Daftar Produk Reagen >< Gen Target PCR</h4>
               </vs-col>
 					     <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
     	          <vs-spacer></vs-spacer>
     						<vs-tooltip text="Tambah">
     							<vs-button radius size="medium" type="border" color="#5d9fc6" icon="add" class="ml-3" @click="openPopup1"></vs-button>
     						</vs-tooltip>
               </vs-col>
             </vs-row>
           </div>
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2">
                <vs-table stripe :data="listMapping1" noDataText="Tidak Ada Data" style="text-align:center; max-height:360px; overflow:scroll">
                    <template slot="thead">
                        <vs-th>Produk Reagen</vs-th>
                        <vs-th>Gen Target</vs-th>
                        <vs-th>Position No.</vs-th>
                        <vs-th>&nbsp;</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{data[indextr].product.name}}
                            </vs-td>
                            <vs-td>
                                {{data[indextr].measure.name}}
                            </vs-td>
                            <vs-td>
                                {{data[indextr].positionNo}}
                            </vs-td>
                            <vs-td>
                                <vs-button radius style="cursor: pointer;" @click="openConfirm1(indextr)" color="danger" icon="delete"></vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
              </div>
            </div>
         </vs-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="$router.go(-1)"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>

      <vs-prompt class="w30"
        title="Form Mapping Pemeriksaan & Produk"
        @accept="addRow"
        accept-text="Simpan"
        cancel-text="Batal"
        :active.sync="activePrompt">
           <vx-card>
             <div class="vx-col w-full mb-2">
              <vs-row class="mt-2">
                <vs-col>
                  <vs-select
                    label="Pemeriksaan"
                    autocomplete
                    v-model="measure"
                    class="w-full"
                    @input-change="searchMeasure"
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listMeasure" />
                  </vs-select>
                  <span
                      class="text-danger text-sm"
                      v-show="measure == '' && validate"
                      >Pemeriksaan harus diisi</span>
                </vs-col>
              </vs-row>
              <vs-row class="mt-4">
                <vs-col>
                  <vs-select
                    label="Produk"
                    autocomplete
                    v-model="product"
                    class="w-full"
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listReagen" />
                  </vs-select>
                </vs-col>
              </vs-row>
             </div>
           </vx-card>
      </vs-prompt>

       <vs-prompt class="w30"
         title="Form Mapping Pemeriksaan Reagen PCR"
         @accept="addRow1"
         accept-text="Simpan"
         cancel-text="Batal"
         :active.sync="activePrompt1">
            <vx-card>
              <div class="vx-col w-full mb-2">
                <vs-row>
                  <vs-col>
                    <vs-select
                      label="Produk Reagen"
                      autocomplete
                      v-model="reagenMeasure"
                      class="w-full"
                      >
                      <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listReagen" />
                    </vs-select>
                    <span
                        class="text-danger text-sm"
                        v-show="reagenMeasure == '' && validate1"
                        >Produk Reagen harus diisi</span>
                  </vs-col>
                </vs-row>
               <vs-row class="mt-2">
                 <vs-col>
                   <vs-select
                     label="Gen Target"
                     autocomplete
                     v-model="genTarget"
                     class="w-full"
                     >
                     <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listGenTarget" />
                   </vs-select>
                   <span
                       class="text-danger text-sm"
                       v-show="genTarget == '' && validate1"
                       >Gen Target harus diisi</span>
                 </vs-col>
               </vs-row>
               <vs-row class="mt-2">
                 <vs-col>
                   <vs-input-number v-model="positionNo" min="1"/>
                 </vs-col>
               </vs-row>
              </div>
            </vx-card>
        </vs-prompt>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import lab from "@/api/lab";
import master from "@/api/master";
import form from "@/api/form";
import tool from "@/tool/form_tool";
import moment from 'moment';

export default {
  components: {
      Datepicker
  },
  data() {
    return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
      },
      listMapping: [],
      listMapping1: [],
      listTest: [],
      loading: false,
      test: null,
      idxSelected: null,
      idxSelected1: null,
      activePrompt: false,
      activePrompt1: false,
      listMeasure: [],
      listReagen: [],
      listReagenMeasure: [],
      listGenTarget: [],
      measure: '',
      product: '',
      reagenMeasure: '',
      genTarget: '',
      positionNo: 1,
      validate: false,
      validate1: false,
      listFormula: [{ id: 1, name: "Satuan" }, { id : 2, name : "Paket"}]
    };
  },
  methods: {
		listen(newVal, schema) {
		},
    openConfirm(id) {
        this.idxSelected = id;
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert
        });
    },
    openConfirm1(id) {
        this.idxSelected1 = id;
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert1
        });
    },
    acceptAlert() {
      this.listMapping.splice(this.idxSelected, 1);
    },
    acceptAlert1() {
      this.listMapping1.splice(this.idxSelected1, 1);
    },
    addRow() {
      if (this.measure !== '') {
        let measure = this.lodash.find(this.listMeasure, o => {
          return o.id === this.measure;
        });

        let x = {}
        x.measure = measure;

        if (this.product !== '') {
          let product = this.lodash.find(this.listReagen, o => {
            return o.id === this.product;
          });

          x.product = product;
        }

        this.listMapping.push(x);
        this.validate=false;
      } else {
        this.validate=true;
        this.activePrompt=true;
      }
    },
    addRow1() {
      if (this.reagenMeasure !== '') {
        let reagenMeasure = this.lodash.find(this.listReagen, o => {
          return o.id === this.reagenMeasure;
        });

        let x = {}
        x.product = reagenMeasure;

        if (this.genTarget !== '') {
          let genTarget = this.lodash.find(this.listGenTarget, o => {
            return o.id === this.genTarget;
          });

          x.measure = genTarget;
        }

        x.positionNo = this.positionNo;

        this.listMapping1.push(x);
        this.validate1=false;
      } else {
        this.validate1=true;
        this.activePrompt1=true;
      }

      this.reagenMeasure='', this.genTarget='';
    },
    onConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin untuk menyimpan data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
      };

      let md = this.model;
      if (md.def == true) {
        md.def = 1;
      } else {
        md.def = 0;
      }

      let ms = [];
      for (let i = 0; i < this.listMapping.length; i++) {
        let lp = this.listMapping[i];
        let me = { measure: {id : lp.measure.id},
                    product: {id : lp.product.id}};
        ms.push(me);
      }
      md.measures = ms;
      ms = [];
      for (let i = 0; i < this.listMapping1.length; i++) {
        let lp = this.listMapping1[i];
        let me = { product: {id : lp.product.id},
                    reagenMeasure: {id : lp.measure.id},
                    positionNo: lp.positionNo};
        ms.push(me);
      }
      md.reagenMeasures = ms;

			master.saveInstrument(md, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di simpan ",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/pemeriksaan/instrument/list"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},
    async getListMeasure() {
			const frm = await lab.listMeasure({perPage: 50, page: 1});
      if (frm.data.status) {
        this.listMeasure = frm.data.data;
      }
    },
    async getListReagen() {
			const frm = await master.listReagen({perPage: 50, page: 1});
      if (frm.data.status) {
        this.listReagen = frm.data.data;
      }
    },
    async getListGenTarget() {
			const frm = await master.listReagenMeasure({perPage: 50, page: 1});
      if (frm.data.status) {
        this.listGenTarget = frm.data.data;
      }
    },
		async firstLoad() {
			const frm = await form.getFormInstrument();
			this.schema.fields = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			if (idx) {
				const xmodel = await master.getInstrument(idx);
        this.model = xmodel.data.data[0];
        this.listMapping = (this.model.measures==null?[]:this.model.measures);
        this.listMapping1 = (this.model.reagenMeasures==null?[]:this.model.reagenMeasures);

        if (this.model.def == 1) {
          this.model.def = true;
        }
			} else {
				this.model = frm.data.data[0].model;
      }
      await this.getLabSection();
      await this.getFormula();
    },
    clear() {
      this.measure = '';
      this.product = '';
    },
    async searchMeasure(event) {
      if (event.target.value.length > 2) {
          const frms = await lab.listMeasure({keyword: event.target.value});
          this.listMeasure = frms.data.data;
      }
    },
    async openPopup() {
      this.activePrompt=true;
      this.validate=false;
      this.clear();

      await this.getListMeasure();
      await this.getListReagen();
    },
    async openPopup1() {
      this.activePrompt1=true;
      this.validate1=false;
      this.positionNo=1;
      //this.clear();

      await this.getListGenTarget();
      await this.getListReagen();
    },
    async getLabSection() {
      const prov = await lab.listBagianLab();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"labSection",
				prov.data.data
			);
    },
    async getFormula() {
      const prov = this.listFormula;
			tool.copyValuesToDropDown(
				this.schema.fields,
				"formula",
				prov
			);
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.firstLoad();
  }
};
</script>


<style lang="scss">
.w30 .vs-dialog {
    max-width:30%;
}

.vs-dialog {
    max-height: 90%;
    overflow-y: auto;
}
.vs-dialog-header {
    padding-right: 22px;
    padding-top: 10px;
}
</style>
